<template>
    <div v-bind:style="{height:heightB+'px'}" style="background:#F2F2F2">
        <Header v-bind:title="'用户中心'" v-bind:back="true"></Header>
        <div class="user">
            <h1 style="color:#606266">您好 {{name}}</h1>
            <!--<van-cell-group title="出生地">-->
                <!--<van-field v-model="form.csd" placeholder="输入出生地" />-->
            <!--</van-cell-group>-->
            <!--<van-cell-group title="联系人">-->
                <!--<van-field v-model="form.lxr" placeholder="输入联系人" />-->
            <!--</van-cell-group>-->
            <!--<van-cell-group title="联系人电话">-->
                <!--<van-field v-model="form.lxrdh" placeholder="输入联系人电话" />-->
            <!--</van-cell-group>-->

            <!--<van-button size="large" class="save-button" type="info" @click="submit()">保存</van-button>-->
            <van-button size="large" class="logout-button" type="danger" @click="logout()">退出</van-button>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    import Header from './Header.vue'
    import {saveEmpiUserInfo} from '@/api/empiApi.js'
    export default{
        name:'',
        components:{Header},
        data(){
            return {
                heightB:document.documentElement.clientHeight,
                name:'',
                form:{
                    csd:'',
                    lxr:'',
                    lxrdh:''
                },
                mdmId:''
            }
        },
        mounted(){
            let info = this.$cookies.get('LOGIN_INFO')
            this.form = {
                csd:info && info.csd ? info.csd : '',
                lxr:info && info.lxr ? info.lxr : '',
                lxrdh:info && info.lxrdh ? info.lxrdh : '',
            }
            this.name  = info && info.xm ? info.xm : ''
            this.mdmId = info && info.mdmId ? info.mdmId : ''
        },
        methods:{
            submit(){
                let props = {
                    CSD:this.form.csd,
                    LXRDH:this.form.lxrdh,
                    LXRXM:this.form.lxr
                }
                if(this.mdmId){
                    saveEmpiUserInfo({
                        mdmId:this.mdmId ? this.mdmId : '',
                        prop:JSON.stringify(props)
                    }).then(res=>{

                    }).catch(err=>{

                    })
                }
            },
            logout(){
                this.$cookies.remove('LOGIN_INFO')
                this.$router.push({ name: 'login'})
            },
        }
    }
</script>
<style scoped>
    .user{
        margin-top:40px;
    }
    .user h1{
        margin: 0;
        font-size: 25px;
        color: #000;
        text-align: center;
        text-transform: uppercase;
        letter-spacing: 2px;
        font-weight: 700;
    }
    .save-button{
        width: 85%;
        margin-top:20px;
        margin-left:10%;
    }
    .logout-button{
        margin-top:30px;
        width: 85%;
        margin-left:10%;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile/components/User.vue